

function NoPage() {

    return (
        <>
            <h1>Error 404</h1>
        </>
    )
}

export default NoPage